const isLocalHost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');

const fallbackBaseUrl = isLocalHost
  ? 'http://localhost:5000'
  : 'https://musician.onrender.com';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || fallbackBaseUrl;
